/**
 * @param tableView for which we want to get the view filter
 * @return Returns the view filter for the table view
 */
export default function getViewFilterForTable(tableView) {
    switch (tableView.tableQuery.type) {
        case 0 /* Folder */:
        case 2 /* Group */:
            return tableView.tableQuery.viewFilter;
        case 1 /* Search */:
            return 'All';
        default:
            throw new Error('Table Query should be either of type search, mail folder or group');
    }
}
//# sourceMappingURL=getViewFilterForTable.js.map